import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Box,
  Button,
} from '@material-ui/core';

import APIS from "../../../utils/APIS"

import SuperAdminContext from "../../../contexts/SuperAdminContext"

import TopBar from "../../../components/ui/Admin/TopBar"

import SideBar from "../../../components/ui/Admin/Formations/SideBar"

import ScaleThumbForm from "../../../components/ui/Formation/ScaleThumbForm"
import { FormatSwitch } from "../../../pages/Formation"

const FormationPlayer = () => {
  const navigate = useNavigate()
  const params = useParams();

  const {
    contents,
    updateAdminContents,
    content,
    setContent,
    playerHasChanged,
    setPlayerHasChanged,
    setOverlayForSave,
    adminPlayerIndexes,
    setAdminPlayerIndexes,
  } = useContext(SuperAdminContext)

  const setActContent = async () => {
    var findContent = contents?.find((l) => l.id.toString() == params?.id)

    if (findContent) {
      if (content == null || content.id !== findContent.id) {
        setOverlayForSave(true)
        let fetchContent = await APIS.getContentByIdForAdmin({id : findContent.id})
        if (fetchContent) {
          sessionStorage.setItem('saveFormationAdmin', JSON.stringify(fetchContent));
          setAdminPlayerIndexes({ chapitre: 0, partie: 0, sequence: 0 })
          setPlayerHasChanged(false)
          setContent(fetchContent)
          setOverlayForSave(false)
        } else {
          navigate("/admin/formation")
        }
      }
    } else {
      navigate("/admin/formation")
    }
  }

  useEffect(() => {
    if (params?.id && contents) {
      setActContent()
    }
  }, [contents, params])

  /*useEffect(() => {
    console.log("content change useEffect")
  }, [content])*/

  const [sequenceSubMenu, setSequenceSubMenu] = useState(false)

  useEffect(() => {
    setSequenceSubMenu(false)
  }, [adminPlayerIndexes])


  return (
    <>
      <Helmet>
        <title>Admin Modules | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box
          sx={{
            flex:1,
            padding:"20px",
            backgroundColor:"background.grey",
          }}
        >

          {content &&
            <Box sx={{
              height:"calc(100vh - 105px)",
              display:"flex",
              overflow:"hidden",
              gap:"10px"
            }}>
              <SideBar
                content={content}
                setContent={setContent}
                actIndex={adminPlayerIndexes}
                setIndex={setAdminPlayerIndexes}
                sequenceSubMenu={sequenceSubMenu}
                setSequenceSubMenu={setSequenceSubMenu}
              />

              <Box sx={{
                height:"100%",
                width:"calc(100vw - 250px)",
                overflow:"hidden",
                display:"flex",
                alignItems:"center",
                justifyContent:"center"
              }}>
                <Box sx={{
                  overflow:"hidden",
                  aspectRatio:"1.5",
                  maxHeight:"100%",
                  maxWidth:"100%",
                  border:"1px solid black"
                }}>
                  <ScaleThumbForm isEditor>
                    <FormatSwitch
                      actFormation={content}
                      format={content?.chapitre[adminPlayerIndexes?.chapitre]?.partie[adminPlayerIndexes?.partie]?.sequence[adminPlayerIndexes?.sequence]}
                      actIndex={adminPlayerIndexes}
                      onlyContent
                      isEditor
                      sequenceSubMenu={sequenceSubMenu}
                      setSequenceSubMenu={setSequenceSubMenu}
                    />
                  </ScaleThumbForm>
                </Box>
              </Box>
            </Box>
          }

        </Box>
      </Box>
    </>
  )
};

export default FormationPlayer;
